// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"xP-z","inlineTitle":"yP-z","sponsoredAdsWrapper":"zP-z","marketplaceRecosWrapper":"AP-z"};